export default {
  path: '/settings',
  name: 'settings',
  redirect: { name: 'settings.dashboard' },
  component: () =>
    import(/* webpackChunkName: "auth" */ '@/views/Home/Settings'),
  children: [
    {
      path: 'dashboard',
      name: 'settings.dashboard',
      component: () =>
        import(
          /* webpackChunkName: "auth" */ '@/views/Home/Settings/Dashboard'
        ),
    },
    {
      path: 'pages/privacy',
      name: 'settings.pages.privacy',
      component: () =>
        import(
          /* webpackChunkName: "auth" */ '@/views/Home/Settings/PageManager/index.vue'
        ),
      props: {
        pageType: 'privacy',
        pageTitle: 'Privacy Policy',
      },
    },
    {
      path: 'pages/support',
      name: 'settings.support',
      component: () =>
        import(
          /* webpackChunkName: "auth" */ '@/views/Home/Settings/Support.vue'
        ),
      props: {
        pageType: 'privacy',
        pageTitle: 'Privacy Policy',
      },
    },
    {
      path: 'pages/terms-and-conditions',
      name: 'settings.pages.terms-and-conditions',
      component: () =>
        import(
          /* webpackChunkName: "auth" */ '@/views/Home/Settings/PageManager/index.vue'
        ),
      props: {
        pageType: 'terms_of_service',
        pageTitle: 'Terms and Conditions',
      },
    },
    {
      path: 'version-control',
      name: 'settings.version-control',
      component: () =>
        import(
          /* webpackChunkName: "auth" */ '@/views/Home/Settings/VersionControl/index'
        ),
    },
  ],
}
